import { useEffect, useRef, useState } from "react";
import ChartWrapper from "./ChartWrapper";
import { useAppSelector } from "../../store/hooks";
import { selectActiveSymbol } from "../../store/chartSlice";

declare global {
    interface Window {
        MyChart?: {
            mount: (el: string | Element, props: any) => void;
            unmount: (el: string | Element) => void;
        };
    }
}

const Charts = () => {
    const instrument = useAppSelector(selectActiveSymbol)
    const chartWrapperRef = useRef<HTMLDivElement>(null);
    const [dimensions, setDimensions] = useState({ width: 600, height: 500 });

    useEffect(() => {


        if (!window.MyChart) {
            console.error("Widget not loaded");
            return;
        }

        window.MyChart.mount("#widget-slot", {
            user: "Harsha from Host"
        });

        return () => {
            window.MyChart?.unmount("#widget-slot");
        };
    }, []);

    useEffect(() => {
        const chartDiv = chartWrapperRef.current;
        if (!chartDiv) return;

        const updateDimensions = () => {
            const rect = chartDiv.getBoundingClientRect();
            console.log("Chart div dimensions:", rect.width, rect.height);
            setDimensions({
                width: rect.width,
                height: rect.height
            });
        };

        // Initial measurement
        updateDimensions();

        // Create ResizeObserver to watch for size changes
        const resizeObserver = new ResizeObserver(updateDimensions);
        resizeObserver.observe(chartDiv);

        return () => resizeObserver.disconnect();
    }, []);

    console.log("Rendering Charts with dimensions:", dimensions);


    return (
        <div ref={chartWrapperRef} style={{ width: '100%', height: '100%' }}>
            <ChartWrapper closeChart={() => { }} instrument={instrument} width={dimensions.width} height={dimensions.height} />
        </div>
    );
}

export default Charts;